import { render, staticRenderFns } from "./productPoint.vue?vue&type=template&id=ad3a5406"
import script from "./productPoint.vue?vue&type=script&lang=js"
export * from "./productPoint.vue?vue&type=script&lang=js"
import style0 from "./productPoint.vue?vue&type=style&index=0&id=ad3a5406&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports